import UploadFileStatus from "./enums/UploadFileStatus";

class UploadFileResult {
  constructor(
    public identifier: string,
    public fileName: string,
    public serverId: number | undefined,
    public status: UploadFileStatus
  ) {}
}

export default UploadFileResult;
